import { useTranslation } from 'react-i18next'

import { URL_ALIASES } from '../../../../constants/route'
import { getQaSelector } from '../../../../utils/common'
import { Link } from '../../../Link'
import { SelectDropdownEmpty } from '../../../Select'

import { QA_NAME_LISTING_FORM_NO_UNITS_LINK } from './RentalPortalListingFlatFieldSelectDropdownEmpty.constants'

import * as styles from './RentalPortalListingFlatFieldSelectDropdownEmpty.module.css'

function RentalPortalListingFlatFieldSelectDropdownEmpty() {
  const { t } = useTranslation()

  return (
    <div className={styles.RentalPortalListingFlatFieldSelectDropdownEmpty}>
      <SelectDropdownEmpty
        className={styles.message}
        text={t('RentalPortal.ListingFormNoUnitsKey')}
      />
      <Link
        {...getQaSelector({ value: QA_NAME_LISTING_FORM_NO_UNITS_LINK })}
        className={styles.action}
        to={URL_ALIASES.flats}
      >
        {t('RentalPortal.ListingFormNoUnitsFlatsLinkKey')}
      </Link>
    </div>
  )
}

export default RentalPortalListingFlatFieldSelectDropdownEmpty
